export class StatusCheckerService {

  constructor() {
    this.unknownStatus = {
      name    : 'unknownStatus',
      cssClass: 'icon-dot-circled unknownStatus',
    };
    this.onlineStatus = {
      name    : 'onlineStatus',
      cssClass: 'icon-clock-circled onlineStatus',
    };
    this.awayStatus = {
      name    : 'awayStatus',
      cssClass: 'icon-clock-circled awayStatus',
    };
    let hour = 3600000;
    this.onlineInterval = hour / 12;
    this.awayInterval = hour / 6;
  }

  check(cell) {
    let last_activity_time, last_report_time;
    if (cell['agent_agent.id']) {
      last_activity_time = cell['agent_agent.last_activity_time'];
      last_report_time = cell['agent_agent.last_report_time'];
    }
    if (cell['agent_account.user_name']) {
      last_activity_time = cell['agent_account.last_activity_time'];
      last_report_time = cell['agent_account.last_report_time'];
    }
    if (!last_report_time) {
      return this.unknownStatus;
    }
    let now = new Date();
    if (last_activity_time) {
      let lat_date = new Date(last_activity_time);
//             console.log('Now: '+now+', lat_date: '+lat_date);
      if ((now - lat_date) < this.onlineInterval) {
        return this.onlineStatus;
      }
    }
    let lrt_date = new Date(last_report_time);
    if ((now - lrt_date) < this.awayInterval) {
      return this.awayStatus;
    }
    return this.unknownStatus;
  }
}



// WEBPACK FOOTER //
// ./src/core/status-checker.service.js